export default __webpack_public_path__ + "static/media/section3-step4.845471e0.png";